import { featureCards } from "@/mocks/chigua";
import SectionHead from "./SectionHead";
import Reveal from "@/components/feature/Reveal";
import { toneChip } from "./tone";

export default function FeatureFlow() {
  return (
    <section id="features" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHead
            kicker="资讯看点 · COVERS"
            title="大图资讯卡片流"
            subtitle="封面驱动的官方资讯看点,年度回顾、公约解读与安全白皮书等你逐个查看。"
            more="浏览全部看点"
            moreHref="#features"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featureCards.map((c, idx) => (
            <Reveal key={c.title} delay={(idx % 3) * 80}>
              <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1.5 hover:border-primary-200">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/35 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"></div>
                  <span className={`absolute left-3 top-3 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${toneChip[c.tone]}`}>
                    {c.tag}
                  </span>
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-950/55 px-2.5 py-1 text-[11px] text-background-100 backdrop-blur">
                    <i className="ri-eye-line"></i>
                    {c.views}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    {c.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                  <div className="mt-auto flex items-center justify-between border-t border-background-200/70 pt-3.5">
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-calendar-line"></i>
                      {c.date}
                    </span>
                    <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                      阅读全文
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}